import { Delay } from '../delayBase'

export class AlwaysDelay extends Delay {}
